import { Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { BookingFilter, BookingList } from '../models/booking.model'
import { ApiEndPoint } from 'src/app/shared/constants/apis.constant'
import { map } from 'rxjs'

@Injectable({ providedIn: 'root' })
export class BookingService {
	constructor(private http: HttpClient) {}

	getBookingsList(filter: BookingFilter) {
		return this.http.post(ApiEndPoint.SearchAllBookingsApi, filter)
	}
	SearchAllTabCount(filter: BookingFilter) {
		return this.http.post(ApiEndPoint.SearchAllTabCountApi, filter)
	}

	getBussinessNames(countryId: any, Keyword: any) {
		return this.http.get(
			`${ApiEndPoint.GetByCountryApi}?countryId=${
				countryId || ''
			}&Keyword=${Keyword}`
		)
	}

	getBookingDetails(id: number) {
		return this.http
			.get(`${ApiEndPoint.GetDetailsApi}?id=${id}`)
			.pipe(map((result: any) => result.result as BookingList))
	}

	cancelBooking(id: number) {
		return this.http.post(`${ApiEndPoint.CancelBookingApi}?id=${id}`, '')
	}

	confirmBooking(id: number) {
		return this.http.post(`${ApiEndPoint.ConfirmBookingApi}?id=${id}`, '')
	}
	completeBooking(id: number) {
		return this.http.post(`${ApiEndPoint.CompleteBookingApi}?id=${id}`, '')
	}

	didNotShowBooking(id: number) {
		return this.http.post(
			`${ApiEndPoint.MarkDidNotShowUpBookingApi}?id=${id}`,
			''
		)
	}
	changeBookingMethod(paymentMethodId: number, id: number) {
		let body = {
			paymentMethodId,
			id,
		}
		return this.http.put(`${ApiEndPoint.UpdatePaymentMethodApi}`, body)
	}
	SearchByServiceProviders(body: any) {
		return this.http.post(ApiEndPoint.SearchByServiceProviderApi, body)
	}
	getUpChargeSummery(newTotal: any, Id: number) {
		return this.http.get(
			`${ApiEndPoint.GetUpChargedSummeryApi}?NewTotal=${newTotal}&Id=${Id}`
		)
	}
	completeBookingWithPriceRange(id: number, newTotal: number) {
		let body = { id, newTotal }
		return this.http.post(
			`${ApiEndPoint.CompleteBookingWithPriceRangeApi}`,
			body
		)
	}
	hideRating(AppointmentId: number) {
		let status = true
		let body = {}
		return this.http.put(
			`${ApiEndPoint.UpdateBookingRatingStatusApi}?AppointmentId=${AppointmentId}&HideComment=${status}`,
			body
		)
	}

	sendOnlineUpchargeRequest(body : any) {
		return this.http.post(`${ApiEndPoint.SendOnlineUpcharegeRequestApi}`, body)
	}
}
